import cancelAttachmentOperation from 'owa-service/lib/operation/cancelAttachmentOperation';

export default function cancelAttachment(cancellationId: string): Promise<boolean> {
    return cancelAttachmentOperation({
        cancellationId: cancellationId,
    });
}
